import React, { useEffect, useState, useContext } from 'react';
import Breadcrumb from '../../../../components/bootstrap/Breadcrumb';
import Card, { CardBody } from '../../../../components/bootstrap/Card';
import Page from '../../../../layout/Page/Page';
import PageWrapper from '../../../../layout/PageWrapper/PageWrapper';
import SubHeader, { SubHeaderLeft, SubHeaderRight } from '../../../../layout/SubHeader/SubHeader';
import OrdersIfoodDB from '../../../../database/wrappers/orderIfood';
import { DefaultContext } from '../../../../contexts/default';
import CardDispute from './CardDispute';
import HeaderOrder from './HeaderOrder';
import ChatDispute from './ChatDispute';
import api from '../../../../services/api';
import SelectEstablishment from "../../../../components/MyCustom/SelectEstablishment"
import SelectStore from "../../../../components/MyCustom/SelectStore"
import { limit, orderBy, where } from 'firebase/firestore';


const Conversas = () => {
	const { estabSelected, storeSelected } = useContext(DefaultContext);
	const [selectedCard, setSelectedCard] = useState(null);
	const [estadoSelected, setEstadoSelected] = useState(null);
	const [data, setData] = useState(null);
	const [orders, setOrders] = useState([]);
	const [filtredOrders, setFiltredOrders] = useState([])
	const [ifoodToken, setIfoodToken] = useState("")

	const handleCardClick = (card) => {
		setSelectedCard(card);
	};

	useEffect(() => {
		api.get("routesIfood/token")
			.then(({ data }) => {
				setIfoodToken(data.accessToken)
			})
	}, [selectedCard, estabSelected])

	useEffect(() => {
		const data = {
			itemsDispute: selectedCard?.disputeData?.garnishItems?.map((item) => {
				let product = {
					name: 'Não informado',
					qtd: item?.quantity,
					unitPrice: item?.amount?.value,
					reason: item?.reason,
					total: parseFloat(item?.amount?.value) * item?.quantity,
				};
				selectedCard?.products?.forEach((i) => {
					if (i?.cdExterno === item?.externalCode) {
						product = {
							...product,
							name: i?.name,
						};
					} else {
						i?.complements?.forEach((c) => {
							if (c?.cdExterno === item?.externalCode) {
								product = {
									...product,
									name: c?.name,
								};
							}
						});
					}
				});
				return product;
			}),
			totalRefund: selectedCard?.disputeData?.garnishItems?.reduce(
				(acc, item) => acc + parseFloat(item?.amount?.value),
				0,
			),
		};

		setData(data);
	}, [selectedCard]);

	useEffect(() => {
		if (estabSelected && storeSelected) {
			const onSubscribe = new OrdersIfoodDB(estabSelected).on((data) => {
				setOrders(data)
			},
				where("disputeStatus", "!=", null),
				where("storeId", "==", storeSelected),
				orderBy("disputeStatus"),
				orderBy("created_at", "desc"),
				limit(40)
			)
			return onSubscribe;
		}
	}, [estabSelected, storeSelected]);

	useEffect(() => {
		if (estadoSelected === null) {
			return setFiltredOrders(orders)
		}

		const filtredOrders = orders.filter((order) => order.disputeStatus === estadoSelected)

		return setFiltredOrders(filtredOrders)
	}, [estadoSelected, orders])

	const maxAmount = selectedCard?.disputeData?.alternatives?.[0].maxAmount?.value;


	const handleChangeStatus = (statusParm) => {
		setSelectedCard(null)
		setEstadoSelected(statusParm)
	}

	return (
		<>
			<PageWrapper title='Conversas' >
				<SubHeader>
					<SubHeaderLeft>
						<Breadcrumb
							list={[
								{ title: 'Home', to: '/' },
								{ title: 'Chamados', to: '/chamados' },
							]}
						/>
					</SubHeaderLeft>
					<SubHeaderRight />
				</SubHeader>

				<Page container='fluid'>
					<div style={{ display: 'flex', width: '90%', justifyContent: 'start', gap: 10, paddingBottom: 15 }}>
						<SelectEstablishment />
						<SelectStore />
					</div>

					<div style={{ display: 'flex' }}>
						<CardDispute orders={filtredOrders} selectedCard={selectedCard} handleCardClick={handleCardClick} estadoSelected={estadoSelected} handleChangeStatus={handleChangeStatus} />
						<div style={{ width: '75%', border: '2px solid #f8f9fa', borderRadius: '15px', backgroundColor: '#f8f9fa', padding: '10px', position: 'relative' }}>

							{selectedCard ? (
								<>
									<HeaderOrder selectedCard={selectedCard} />
									<ChatDispute data={data} selectedCard={selectedCard} maxAmount={maxAmount} ifoodToken={ifoodToken} setSelectedCard={setSelectedCard} />


								</>
							) : (
								<p>Selecione uma conversa para visualizar os detalhes.</p>
							)}
						</div>
					</div>
				</Page>
			</PageWrapper>
		</>
	);
};

export default Conversas;
